<template>
  <div class="plugin pluginStyle">
    <!-- 搜索 -->
    <div class="plugin-search" style="padding: 15rem 0px 4rem 0">
      <div class="search-fff">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <!-- <el-form-item>
            <el-date-picker
              type="date"
              v-model="formInline.time"
              placeholder="2022-11-23"
            >
            </el-date-picker>
          </el-form-item> -->
          <el-form-item label="Name：">
            <el-input
              v-model="formInline.name"
              class="formInput"
              placeholder="search for name"
            ></el-input>
          </el-form-item>

          <el-form-item label="Type：">
            <el-select
              placeholder="Type"
              class="formInput"
              v-model="formInline.type"
            >
              <el-option label="whole" value=""></el-option>
              <el-option label="elf" value="elf"></el-option>
              <el-option label="script" value="script"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchClick()">search</el-button>
            <el-button @click="resetClick()">reset</el-button>
          </el-form-item>
        </el-form>
        <span @click="pluginCilck">add plugin</span>
      </div>
    </div>

    <!-- 表格 -->
    <div class="keshihua-table-three">
      <div class="plugin-table">
        <el-card class="box-card" v-for="item in tableData" :key="item.id">
          <div slot="header" class="clearfix">
            <span class="cad-tile" @click="detaClick(item)">{{
              item.name
            }}</span>
            <i @click="delClick(item)" class="el-icon-delete ioncal"></i>
            <i
              @click="pluginEdit(item)"
              class="el-icon-edit-outline ioncas"
            ></i>
          </div>
          <div
            slot="header"
            class="clearfix"
            style="margin-top: 15rem; font-size: 15px"
          >
            <span>{{ item.remark }}</span>
            <span style="float: right">{{ item.time }}</span>
          </div>
          <ul class="text item ul_cade">
            <li v-for="items in item.file" :key="items.id">
              <span>{{ items.arch }}</span>
              <span style="margin-left: 20rem; color: #546afc">{{
                items.file_name
              }}</span>
              <el-upload
                style="float: right"
                class="upload-demo"
                action=""
                :on-preview="upCliack"
                :on-change="getFile"
                list-type="picture"
                :auto-upload="false"
                accept=""
                :show-file-list="false"
              >
                <i
                  style="color: green"
                  class="el-icon-upload"
                  @click="upId(item.id, items.arch)"
                />
              </el-upload>
            </li>
          </ul>
        </el-card>
      </div>
    </div>
    <!-- 分页 -->
    <div class="task-paging" style="float: left">
      <div class="pagination-fff">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pages.page"
          :page-sizes="[10, 30, 50]"
          :page-size="pages.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pages.total"
        ></el-pagination>
      </div>
    </div>
    <div class="daping-dialog2">
      <pluginAdd
        @newDialogFun="newDialogFun"
        :editId="editId"
        ref="pluginRef"
      />
    </div>
    <div class="daping-dialog2">
      <pluginDetail @detaCel="detaCel" :detaCont="detaCont" ref="detaRef" />
    </div>
  </div>
</template>

<script>
import pluginAdd from '@/components/admin/plugin/pluginAdd.vue';
import pluginDetail from '@/components/admin/plugin/pluginDetail.vue';

import { getplugnList, getDelete, geUploadList } from '@/api/plugin';
export default {
  name: 'plugin',
  components: {
    pluginAdd,
    pluginDetail,
  },
  data() {
    return {
      editId: '',
      pages: {
        size: 10,
        page: 1,
        total: 0,
      },
      fiilLength: [],
      files: [],

      formInline: {
        name: '',
        type: '',
      },
      tableData: [],
      // tableList: [],
      puId: '',
      archs: '',
      detaCont: {},
    };
  },
  created() {},
  mounted() {
    this.getpluginInfoFun();
  },
  computed: {
    title() {
      return this.$route.meta.title;
    },
  },
  methods: {
    upCliack(val) {},
    upId(val, value) {
      this.puId = val;
      this.archs = value;
    },
    getFile(file, row) {
      let formData = new FormData();
      let fiLes = file.raw;
      formData.append('file', fiLes, fiLes.name);
      formData.append('id', this.puId);
      formData.append('arch', this.archs);

      geUploadList(formData).then((res) => {
        if (res.data.code == 200) {
          this.getpluginInfoFun();
          this.$message.success(res.data.msg);
        } else {
          this.$message.success(res.data.msg);
        }
      });
      console.log(file, row);
    },
    newDialogFun() {
      this.getpluginInfoFun();
    },
    detaClick(val) {
      this.detaCont = val;
      this.$refs.detaRef.detailFalse = true;
    },
    detaCel() {
      this.detaCont = {};
      this.editId = '';

      // this.getpluginInfoFun();
    },
    // 表格请求接口
    getpluginInfoFun() {
      // 深克隆数据
      let formInlineData = this.$globalProcessing.depthCopy(this.formInline);
      let pageData = this.$globalProcessing.depthCopy(this.pages);

      getplugnList({ ...formInlineData, ...pageData }).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.data;
          this.pages.total = res.data.data.total;
        } else {
          this.$globalProcessing.reportErrors.error(res.data.msg);
          this.tableData = [];
        }
      });
    },
    // 当前页
    handleCurrentChange(data) {
      this.pages.page = data;
      this.getpluginInfoFun();
    },
    // 当前页条数
    handleSizeChange(data) {
      this.pages.page = 1;
      this.pages.size = data;
      this.getpluginInfoFun();
    },
    // 搜素
    searchClick() {
      this.pages.page = 1;
      this.getpluginInfoFun();
    },
    // 重置
    resetClick() {
      this.formInline = {};
      this.formInline.type = '';
      // this.dateFun();
      this.pages.page = 1;
      this.getpluginInfoFun();
    },
    pluginCilck() {
      this.$refs.pluginRef.appLicModel = true;
      this.editId = '';
    },
    pluginEdit(row) {
      this.$refs.pluginRef.appLicModel = true;
      this.editId = row;
    },

    delClick(val) {
      this.$confirm(
        'This operation will permanently delete this content. Do you want to continue?',
        'Tips',
        {
          confirmButtonText: 'determine',
          cancelButtonText: 'cancel',
          type: 'warning',
        },
      )
        .then(() => {
          getDelete(val.id).then((res) => {
            if (res.data.code == 200) {
              this.$globalProcessing.reportErrors.success(res.data.msg);
              this.getpluginInfoFun();
            } else {
              this.$globalProcessing.reportErrors.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$globalProcessing.reportErrors.message('Deletion cancelled');
        });
    },
  },
};
</script>

<style scoped lang="less">
// tabs 切换颜色
/deep/.el-tabs__item {
  color: black;
  font-size: 16rem;
}
// form字体大小
/deep/.el-form-item .el-form-item__label {
  font-size: 15rem;
}
/deep/.el-table tr {
  height: 50px;
}
.search-fff {
  position: relative;
  span {
    position: absolute;
    right: 0;
    top: 0;
    padding: 10rem 20px;
    font-size: 16rem;
    color: #546afc;
    border-radius: 10rem 10rem;
    float: right;
    background: #e8efff;
    cursor: pointer !important;
  }
}
.box-card {
  width: 18%;
  display: inline-block;
  margin: 0 18rem 30rem 18rem;
  .cad-tile {
    font-size: 20px;
    font-weight: bold;
    cursor: pointer;
  }
  .ioncal {
    float: right;
    font-size: 19px;
    color: red;
  }
  .ioncas {
    float: right;
    margin-right: 5rem;
    font-size: 19px;
    color: #546afc;
  }
  .ul_cade {
    list-style: none;
    font-size: 14px;
    li {
      line-height: 30px;
    }
  }
}
.pluginStyle {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;

  .keshihua-table-three {
    flex: 1;
    position: relative;
    float: left;
    .plugin-table {
      padding-top: 40rem;
      width: 100%;
      height: 100%;
      margin: auto;
      .red {
        color: #fe4e4e;
        background: #ffe6e7;
      }
      .blue {
        color: #546afc;
        background: #e8efff;
      }
      .btn-style {
        padding: 6rem 20rem;
        border-radius: 10rem 10rem;
        display: inline-block;
        cursor: pointer;
        margin: 0 5rem;
        // border-radius: 10%;
      }
    }
  }
}
</style>
